// TDS Configuration Form Handler for Partner Show Page
document.addEventListener('DOMContentLoaded', function() {
  const tdsForm = document.getElementById('tdsConfigForm');
  if (!tdsForm) return;

  tdsForm.addEventListener('submit', function(e) {
    e.preventDefault();

    const formData = new FormData(this);
    const selectedIds = formData.getAll('zoho_tds_slab_ids[]');
    const statusMessage = document.getElementById('tdsStatusMessage');
    const submitBtn = this.querySelector('button[type="submit"]');
    const updateUrl = this.dataset.updateUrl;

    submitBtn.disabled = true;
    statusMessage.textContent = 'Saving...';
    statusMessage.className = 'text-info';

    fetch(updateUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({ zoho_tds_slab_ids: selectedIds })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        statusMessage.textContent = data.message;
        statusMessage.className = 'text-success';
      } else {
        statusMessage.textContent = data.message || 'Failed to update configuration';
        statusMessage.className = 'text-danger';
      }
    })
    .catch(error => {
      console.error('Error:', error);
      statusMessage.textContent = 'An error occurred while saving';
      statusMessage.className = 'text-danger';
    })
    .finally(() => {
      submitBtn.disabled = false;
      setTimeout(() => {
        statusMessage.textContent = '';
      }, 3000);
    });
  });
});
